// @ts-check
// Vínculos de uma nota ou tarefa (noteTarget, taskTarget) como itens de tela (doc 10, seção 6.5): cada junção aponta para
// um registro por um campo target<Objeto>; a lista sai sem repetir o mesmo registro.

/**
 * @typedef {{ name: string, type: string, relation?: { type?: string, targetObjectNameSingular?: string } | null }} JunctionField
 * @typedef {{ junctionId: string, objectNameSingular: string, recordId: string, record: any, idFieldName: string }} ActivityTargetItem
 */

/** @param {JunctionField} field */
const isTargetField = (field) => field.type === 'RELATION' && field.relation?.type === 'MANY_TO_ONE' && field.name.startsWith('target');

/**
 * @param {JunctionField[]} junctionFields campos do objeto de junção
 * @param {any[]} junctions junções lidas com depth=1 (o registro alvo expandido em target<Objeto>)
 * @returns {ActivityTargetItem[]}
 */
export function toActivityTargetItems(junctionFields, junctions) {
  /** @type {Map<string, ActivityTargetItem>} */
  const items = new Map();
  for (const junction of junctions) {
    for (const field of junctionFields) {
      if (!isTargetField(field)) continue;
      const idFieldName = `${field.name}Id`;
      const recordId = junction[idFieldName] ?? junction[field.name]?.id;
      const objectNameSingular = field.relation?.targetObjectNameSingular;
      if (!recordId || !objectNameSingular) continue;
      const key = `${objectNameSingular}:${recordId}`;
      if (!items.has(key)) items.set(key, { junctionId: junction.id, objectNameSingular, recordId, record: junction[field.name] ?? { id: recordId }, idFieldName });
    }
  }
  return [...items.values()];
}

/**
 * Coluna da junção para um objeto alvo (ex.: targetPersonId), ou null quando a atividade não pode ser ligada a ele.
 * @param {JunctionField[]} junctionFields @param {string} objectNameSingular
 */
export function findTargetIdFieldName(junctionFields, objectNameSingular) {
  const field = junctionFields.find((candidate) => isTargetField(candidate) && candidate.relation?.targetObjectNameSingular === objectNameSingular);
  return field ? `${field.name}Id` : null;
}
